// Fullscreen API e Wake Lock são "melhor esforço": o navegador pode negar (fora de
// gesto do usuário, política da TV/kiosk, API ausente). Nunca lançam.

export async function entrarEmTelaCheia(): Promise<void> {
  try {
    if (!document.fullscreenElement) await document.documentElement.requestFullscreen?.();
  } catch {
    // Segue em janela normal.
  }
}

export async function sairDaTelaCheia(): Promise<void> {
  try {
    if (document.fullscreenElement) await document.exitFullscreen();
  } catch {
    // Já saiu.
  }
}

/** Mantém a tela acesa enquanto a aba estiver visível. Devolve a função de limpeza. */
export function manterTelaAcesa(): () => void {
  let sentinela: WakeLockSentinel | null = null;
  let ativo = true;

  async function pedir() {
    try {
      if (ativo && document.visibilityState === "visible" && "wakeLock" in navigator) {
        sentinela = await navigator.wakeLock.request("screen");
      }
    } catch {
      // Sem permissão/suporte: a TV pode apagar pela configuração dela.
    }
  }

  // O navegador solta o wake lock quando a aba fica oculta; pede de novo na volta.
  const aoMudarVisibilidade = () => void pedir();
  document.addEventListener("visibilitychange", aoMudarVisibilidade);
  void pedir();

  return () => {
    ativo = false;
    document.removeEventListener("visibilitychange", aoMudarVisibilidade);
    void sentinela?.release().catch(() => undefined);
  };
}
